export const UPDATE_FLAGS = "UPDATE_FLAGS";
export const CREATE_UW_JUDGMENT = "CREATE_UW_JUDGMENT";
export const CREATE_EXPOSURE_FLAG = "CREATE_EXPOSURE_FLAG";
export const UPDATE_UW_JUDGMENT = "UPDATE_UW_JUDGMENT";
export const UPDATE_EXPOSURE_FLAG = "UPDATE_EXPOSURE_FLAG";
export const UPDATE_STATE_ID = "UPDATE_STATE_ID";
export const DELETE_UW_JUDGMENT = "DELETE_UW_JUDGMENT";
export const DELETE_EXPOSURE = "DELETE_EXPOSURE";
export const UPDATE_JUDGMENT_IGNORE_OVERRIDE =
  "UPDATE_JUDGMENT_IGNORE_OVERRIDE";
